export const APP_URL = 'https://semanja.it/php/';
export const CAT_IMG_URL = 'https://semanja.it/storage/cat/';
export const MENU_IMG_URL = 'https://semanja.it/storage/menu/';